/**
 * Body do POST `/api/Swap/GravarSessao?guid={guid}`
 * (corresponde ao C# `SwapGravarSessaoRequestViewModel`).
 *
 * Todos os campos abaixo são OBRIGATÓRIOS, exceto `cdProduto` e
 * `bypass`. As validações de negócio são feitas dentro da procedure.
 *
 * O `bypass` é uma propriedade opcional do request (default `false` no
 * backend). Quando `true`, o backend aplica `PR_APP_GESTOR_INS_BYPASS`
 * imediatamente após gravar a sessão; o resultado vem no campo
 * `bypass` da {@link SwapGravarSessaoResponse}.
 */
export interface SwapGravarSessaoRequest {
  /** Identificador externo da sessão (ex.: GUID do cliente). */
  dscSessionExterna: string;
  codMotorista: number;
  /**
   * Placa do veículo. NOTA: o ViewModel C# está como `PawPlaca`
   * (provável typo de "Placa"); mantido fiel ao backend.
   */
  pawPlaca: string;

  vlrPreco: number;
  qtdVolume: number;
  vlrTotal: number;
  numKm: number;

  /** Código do combustível (opcional). Até 4 caracteres. */
  cdProduto?: string;

  /**
   * Quando `true`, o backend aplica o bypass imediatamente após
   * gravar a sessão. Default `false` (idem default do backend).
   *
   * Por segurança, este flag fica **no body** (não na query string)
   * para não aparecer em logs de IIS, proxies ou Referer.
   */
  bypass?: boolean;
}
